<template>
  <div class="table-page">
    <el-card
      class="box-card"
      :body-style="{ padding: bodyPadding, border: bodyBorder }"
      :shadow="shadowType"
    >
      <slot name="headerInput" />
      <div class="flex-box fx-al-c fx-ju-sb">
        <slot name="header" />
      </div>
      <!-- 表格 -->
      <div id="tablearea" class="table-area">
        <el-table
          v-if="isTable"
          ref="table"
          width="100%"
          :empty-text="emptyText"
          border
          :height="height"
          :size="tableSize"
          :data="tableData"
          :stripe="stripe"
          :cell-style="cellStyle"
          highlight-current-row
          :show-summary="showSummary"
          :row-key="getRowkey"
          :default-expand-all="expandAll"
          :expand-row-keys="expandRowKeys"
          @filter-change="filterChange"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-dblclick="rowDbclick"
          @cell-click="cellClick"
          @row-click="rowClick"
          @selection-change="selectionChange"
          @sort-change="sortChange"
          v-bind="$attrs"
          :summary-method="getSummaries"
        >
          <el-table-column
            v-for="(item, index) in columns"
            :type="item.type"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minWidth"
            :width="item.width"
            :align="item.align"
            :fixed="
              ['selection', 'index', 'expand'].includes(item.type)
                ? item.fixed || 'left'
                : item.fixed
            "
            :show-overflow-tooltip="
              item.hasOwnProperty('showOverflowTooltip') == true
                ? item.showOverflowTooltip
                : true
            "
            :filters="item.hasOwnProperty('filters') ? item.filters : null"
            :sortable="item.sortable"
          >
            <template
              v-if="!['selection', 'index', 'expand'].includes(item.type)"
              #default="scope"
            >
              <!-- 插槽 -->
              <div v-if="item.dataType == 'slot'">
                <slot :name="item.prop" :row="scope.row" :index="scope.$index" />
              </div>
              <!-- tag -->
              <div v-else-if="item.dataType == 'tag'">
                <el-tag
                  v-if="
                    typeof dataTypeFn(scope.row[item.prop], item.formatData) == 'string'
                  "
                  :title="
                    item.formatters ? item.formatters(scope.row) : scope.row[item.prop]
                  "
                  :type="formatType(scope.row[item.prop], item.formatType)"
                >
                  {{
                    item.formatters ? item.formatters(scope.row) : scope.row[item.prop]
                  }}
                </el-tag>
              </div>
              <!-- img -->
              <div v-else-if="item.dataType == 'img'">
                <el-image
                  v-if="scope.row[item.prop]"
                  :src="scope.row[item.prop] || scope.row[item.extProp]"
                  :title="scope.row[item.prop] || scope.row[item.extProp]"
                  :width="item.imgWidth"
                  :height="item.imgHeight"
                />
              </div>
              <!-- 默认纯展示数据 -->
              <div v-else>
                <div
                  v-if="!item.formatters"
                  class="column-row"
                  :class="{
                    ellipsis: item.showOverflowTooltip ? item.showOverflowTooltip : true,
                  }"
                >
                  {{ scope.row[item.prop] }}
                </div>
                <div
                  v-else
                  class="column-row"
                  :class="{
                    ellipsis: item.showOverflowTooltip ? item.showOverflowTooltip : true,
                  }"
                >
                  {{ item.formatters && item.formatters(scope.row) }}
                </div>
              </div>
            </template>
            <template v-if="item.children && item.children.length > 0">
              <el-table-column
                v-for="(child, index) in item.children"
                :type="child.type"
                :key="index"
                :prop="child.prop"
                :label="child.label"
                :min-width="child.minWidth"
                :width="child.width"
                :align="child.align"
                :fixed="
                  ['selection', 'index', 'expand'].includes(child.type)
                    ? child.fixed || 'left'
                    : child.fixed
                "
                :show-overflow-tooltip="
                  child.hasOwnProperty('showOverflowTooltip') == true
                    ? child.showOverflowTooltip
                    : true
                "
                :filters="child.hasOwnProperty('filters') ? child.filters : null"
              >
                <template
                  v-if="!['selection', 'index', 'expand'].includes(child.type)"
                  #default="scope"
                >
                  <!-- 插槽 -->
                  <div v-if="child.dataType == 'slot'">
                    <slot :name="child.prop" :row="scope.row" :index="scope.$index" />
                  </div>
                  <!-- tag -->
                  <div v-else-if="child.dataType == 'tag'">
                    <el-tag
                      v-if="
                        typeof dataTypeFn(scope.row[child.prop], child.formatData) ==
                        'string'
                      "
                      :title="
                        child.formatters
                          ? child.formatters(scope.row)
                          : scope.row[child.prop]
                      "
                      :type="formatType(scope.row[child.prop], child.formatType)"
                    >
                      {{
                        child.formatters
                          ? child.formatters(scope.row)
                          : scope.row[child.prop]
                      }}
                    </el-tag>
                  </div>
                  <!-- img -->
                  <div v-else-if="child.dataType == 'img'">
                    <el-image
                      v-if="scope.row[child.prop]"
                      :src="scope.row[child.prop] || scope.row[child.extProp]"
                      :title="scope.row[child.prop] || scope.row[child.extProp]"
                      :width="child.imgWidth"
                      :height="child.imgHeight"
                    />
                  </div>
                  <!-- 默认纯展示数据 -->
                  <div v-else>
                    <div
                      v-if="!child.formatters"
                      class="column-row"
                      :class="{
                        ellipsis: child.showOverflowTooltip
                          ? child.showOverflowTooltip
                          : true,
                      }"
                    >
                      {{ scope.row[child.prop] }}
                    </div>
                    <div
                      v-else
                      class="column-row"
                      :class="{
                        ellipsis: child.showOverflowTooltip
                          ? child.showOverflowTooltip
                          : true,
                      }"
                    >
                      {{ child.formatters && child.formatters(scope.row) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->

      <div :style="fenyeStyle" class="pagination-container">
        <slot name="pagination">
          <el-pagination
            :small="smallPag"
            :current-page.sync="table.pageNum"
            :page-size="table.pageSize"
            :total="table.count"
            :page-sizes="pageSizes"
            :layout="layout"
            background
            class="pagination"
            @current-change="changePage"
            @size-change="changeSize"
          />
        </slot>
      </div>
    </el-card>
  </div>
</template>

<script>
/** 公共表格 */
export default {
  name: "CbTable",
  props: {
    // 传入的表格数据
    table: {
      type: Object,
      default: () => ({
        data: [], // 数据
        page: 1, // 当前页数
        limit: 10, // 一页显示数量
        count: 0, // 总数量
      }),
    },
    resetScroll: {
      type: Boolean,
      default: true,
    },
    cellStyle: {
      type: Function,
      default: (param) => {},
    },
    // 斑马纹表格
    stripe: {
      type: Boolean,
      default: false,
    },
    // 竖直方向边框
    border: {
      type: Boolean,
      default: false,
    },
    // 总计行
    showSummary: {
      type: Boolean,
      default: false,
    },
    // 总计方法
    summaryMethod: {
      type: Function,
      default: (param) => {},
    },
    // 全部展开
    expandAll: {
      type: Boolean,
      default: false,
    },
    // 默认展开的行的id
    expandRowKeys: {
      type: Array,
      default: () => [],
    },
    // 分页style
    fenyeStyle: {
      type: Object,
    },
    // 分页数设置
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40],
    },
    loading: {
      default: false,
    },
    // 是否表格
    isTable: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Array,
      default: [],
    },
    heightTable: {
      type: String,
      default: "",
    },
    smallPag: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: "total,prev,pager,next,sizes,jumper",
    },
    destroy: {
      //是否销毁缩放事件
      type: Boolean,
      default: true,
    },
    bodyPadding: {
      //card内边距
      type: String,
      default: "10px 20px",
    },
    bodyBorder: {
      type: String,
      default: "1px solid #EBEEF5",
    },
    shadowType: {
      //card内边距
      type: String,
      default: "never",
    },
    showPagination: {
      //是否展示分页
      type: Boolean,
      default: true,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    noDataText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      height: 270,
      //    emptyText:"正在加载",
    };
  },
  computed: {
    // 返回表格选择项
    selection() {
      if (this.isTable) {
        return this.$refs.table.selection;
      }
      return this.$refs.cardTable.selection;
    },
    // 根据分辨率控制表格大小
    tableSize() {
      // const screenWidth = window.screen.width
      // console.log(screenWidth);
      // if (screenWidth > 1920) {
      //   return 'large'
      // }
      // if (screenWidth <= 1920 && screenWidth > 1680) {
      return "medium";
      // }
      // if (screenWidth <= 1680 && screenWidth >= 1367) {
      //   return 'small'
      // }
      // return 'mini'
    },
    emptyText() {
      if (this.loading) {
        return "正在加载";
      } else {
        return this.noDataText || "暂无数据";
      }
    },
  },
  watch: {
    // 数据变化时表格滑动到最顶端
    tableData: {
      deep: true,
      handler(newVal) {
        if (newVal && this.resetScroll) {
          if (this.isTable) {
            this.$refs.table.bodyWrapper.scrollTop = 0;
          } else {
            this.$refs.cardTable.scrollTop = 0;
          }
          //数据变化对 Table 进行重新布局
          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout();
          });
        }
      },
    },
    heightTable: {
      handler(value, oldValue) {
        this.height = value || this.height;
      },
      deep: true,
    },
  },

  mounted() {
    this.clientHeight();
  },
  updated() {},
  destroyed() {
    if (this.destroy) {
      window.onresize = null;
    }
  },
  activated() {
    this.clientHeight();
  },
  methods: {
    /** 合并单元格 */
    onArraySpanMethod({ row, column, rowIndex, columnIndex }) {
      this.$emit("spanMethod", { row, column, rowIndex, columnIndex });
    },
    clientHeight(gapHeight) {
      //重新渲染表格样式，防止表格样式错乱
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.doLayout();
      });
      if (!this.heightTable) {
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$refs.table && this.myUtils.pageTableHeight(this, gapHeight);
        });
      } else {
        this.$nextTick(() => {
          this.height = this.heightTable;
          this.$refs.table && this.$refs.table.doLayout();
        });
      }
    },
    // 全选
    toggleAllSelection() {
      if (this.isTable) {
        this.$refs.table.toggleAllSelection();
      } else {
        this.$refs.cardTable.toggleAllSelection();
      }
    },
    //切换
    toggleRowSelection(row, boolValue = true) {
      if (this.isTable) {
        this.$refs.table.toggleRowSelection(row, boolValue);
      } else {
        this.$refs.cardTable.toggleAllSelection(row, boolValue);
      }
    },
    clearSelection() {
      if (this.isTable) {
        this.$refs.table.clearSelection();
      } else {
        this.$refs.cardTable.clearSelection();
      }
    },

    // 换页
    changePage(e) {
      this.$emit("changePage", e);
    },
    // 更换每页显示数量
    changeSize(e) {
      this.$emit("changeSize", e);
    },
    getRowkey(row) {
      return row.id;
    },
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    rowDbclick(row, column, event) {
      this.$emit("row-dblclick", row, column, event);
    },
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    filterChange(e) {
      this.$emit("filter-change", e);
    },
    clearFilter(e) {
      this.$refs.table.columns[e] && (this.$refs.table.columns[e].filteredValue = []);
    },
    selectionChange(e) {
      this.$emit("selection-change", e);
    },
    sortChange(e) {
      this.$emit("sort-change", e);
    },
    formatType(val, format) {
      if (typeof format === "function") {
        return format(val);
      } else return "";
    },
    dataTypeFn(val, format) {
      if (typeof format === "function") {
        return format(val);
      } else return val;
    },
    tableSizeFn(size) {
      this.tabelSize = size;
    },
    getSummaries(param) {
      this.$emit("summary-method", param, (summary) => {
        return summary;
      });
      return [];
    },
    getTableEl() {
      return this.$refs.table;
    },
  },
};
</script>
<style lang="less" scoped>
.column-row {
  white-space: nowrap;
  &.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CbTable.vue